(function () {
    let productCards = document.querySelectorAll('.product-card a');

    for (let i = 0; i < productCards.length; i++) {
        productCards[i].addEventListener('click', openModal)
    }

    function openModal(e) {
        // Prevent opening PDP
        e.preventDefault();

        // Open modal
        const url = e.currentTarget.getAttribute('href');
        const modal = document.querySelector(`quick-view-modal[data-product-url="${url}"]`);
        const trigger = document.querySelector(`[aria-controls="${modal.id}"]`);
        trigger.click();
    }
})();